// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel } from '../../_base/crud';
// Models

// Ngrx
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from '../../../../environments/environment';
import { PatientImageChangeRequest } from '../_models/patient-image-change-request.model';

@Injectable()
export class PatientImageChangeRequestService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  private static getPatientsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;

    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    fromString = filter.status ? `${fromString}&status=${filter.status}` : fromString;

    return fromString;
  }

  findRequests(queryParams: QueryParamsModel): Observable<any> {
    const params = new HttpParams({
      fromString: PatientImageChangeRequestService.getPatientsListQueryString(queryParams),
    });
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/patients/image-change-request`;

    return this.http.get<any>(url, { params, headers });
  }

  denyRequest(request: PatientImageChangeRequest, reason: string): Observable<any> {
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/patients/${request.patient_id}/image-change-request/${request.id}/deny`;
    const body = { id: request.id, denial_reason: reason };

    return this.http.post<any>(url, body, { headers });
  }

  approveRequest(request: PatientImageChangeRequest): Observable<any> {
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/patients/${request.patient_id}/image-change-request/${request.id}/approve`;
    const body = { id: request.id };

    return this.http.post<any>(url, body, { headers });
  }
}
